import React, { useState, useContext } from 'react';
import axios from 'axios';
import NotificationContext from '../NotificationContext';
import './ReviewModal.css';

const ReviewModal = ({ booking, onClose, onReviewSuccess }) => {
    const [rating, setRating] = useState('');
    const [comment, setComment] = useState('');
    const { showNotification } = useContext(NotificationContext);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (!token) {
            showNotification('Please log in to submit a review.', 'error');
            return;
        }

        try {
            await axios.post('https://local-technician-finder-backend.onrender.com/api/reviews', {
                bookingId: booking._id,
                technicianId: booking.technicianId._id,
                rating,
                comment
            }, {
                headers: {
                    'x-auth-token': token
                }
            });
            showNotification('Review submitted successfully!', 'success');
            onReviewSuccess(booking._id); // Notify parent to update booking status
            onClose(); // Close the modal
        } catch (err) {
            console.error(err.response.data);
            showNotification(err.response.data.msg || 'Failed to submit review.', 'error');
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h5>Submit Review for {booking.serviceId.name}</h5>
                    <button type="button" className="modal-close-button" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <div className="form-group">
                            <label className="form-label">Rating (1-5):</label>
                            <input
                                type="number"
                                name="rating"
                                value={rating}
                                onChange={(e) => setRating(e.target.value)}
                                min="1"
                                max="5"
                                className="form-control"
                                required
                            />
                        </div>
                        <div className="form-group mt-3">
                            <label className="form-label">Comment:</label>
                            <textarea
                                name="comment"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                placeholder="Your comments..."
                                maxLength="500"
                                className="form-control"
                            ></textarea>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary">Submit Review</button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReviewModal;